// extracted by css-extract-rspack-plugin
export default {"chip":"chip-fCEceU","chipLabel":"chipLabel-PtR4nL","chipRemove":"chipRemove-J4n883"};